
export const SAWAMURA = { name: 'LHP | Sawamura Eijun',
    role: 'Pitcher | Nagano Prefecture',
    details: 'Throws Right',
    edu: 'Seidou High School ',
    affiliation: 'NPB - Orix Buffaloes',
    photo:'/Sawamura.png'
}

export const CHRIS = { name: 'C | Takigawa Chris Yuu',
    role: 'Catcher | Tokyo',
    details: 'Throws Right, Bats Right',
    edu: 'Faculty of Commerce, Keio University | Seidou High School ',
    affiliation: 'NPB - Orix Buffaloes',
    photo:'/Chris.PNG'
}

export const TETSU = { name: '1B | Tetsuya Yuki',
    role: 'First Base | 4th year | Tokyo',
    details: 'Throws Right, Bats Right',
    edu: 'Literature, Hosei University | Seidou High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Tetsu.png'
}

export const RYOUSUKE = { name: '2B | Kominato Ryousuke',
    role: 'Second Base/Shortstop | 4th year | Kanagawa Prefecture',
    details: 'Throws Right, Bats Left',
    edu: 'Medical Engineering, Toin University of Yokohama | Seidou High School ',
    affiliation: 'Kanagawa University Baseball Federation',
    photo:'/Ryousuke.png'
}

export const HARUICHI = { name: 'SS | Kominato Haruichi',
    role: 'Shortstop/Second Base | 2nd year | Kanagawa Perfecture',
    details: 'Throws Right, Bats Right',
    edu: 'Sport and Health Science, Toin University of Yokohama | Seidou High School ',
    affiliation: 'Kanagawa University Baseball Federation',
    photo:'/Haruichi.png'
}



